import React from 'react';
 import {NavLink} from "react-router-dom";
import Logo from '../../components/logo/Logo';
import FooterData from '../../data/Footer/footerItem.json';
import FooterLinkItem from '../../components/Footer/FooterLinkItem.jsx';
// import 'reactjs-popup/dist/index.css';
import   '../../pages/PopUp/PopUp.css';


// import NewsletterForm from '../../components/Newsletter/NewsletterForm';
// import Newsletter from '../Newsletter/Newsletter';

const Footer = () => {

    const Year = new Date();
    let CurrentYear = Year.getFullYear();

    // const loads = () => {

    //     if(window){
    //         alert("yes")

    //     }else
    //     {
    //         alert("no")
    //     }

    // }

    return (
        <div className="footer-section section footer-bg-color" >
            <div className="container">
            
                {/* adds bottom margin after footer menu */}
                {/* <div className="row mb-lg-14 mb-md-10 mb-6"> */}
            {/* {document.addEventListener("DOMContentLoaded", () => {})} */}
            


                <div className='row'>
                    
                    <div className="col-xl-6 col-lg-4 col-md-4 col-sm-8 col-12 col-12 mb-6">
                        
                        <div className="footer-widget">

                            <div className="footer-logo">
                            {/* <NewsletterForm mailchimpUrl="//devitems.us11.list-manage.com/subscribe/post?u=6bbb9b6f5827bd842d9640c82&amp;id=05d85f18ef" /> */}

                                <Logo 
                                    LogoFooterText='Ikabit Inc'
                                />
                            </div>
                            <div className="footer-widget-content">
                                <div className="content">


                                    <p><a href='tel:+1-855-4522-481' >+1 855-IKABIT-1</a></p>
                                    {/* <p><Link to={process.env.PUBLIC_URL + "/"}>hello@hasagency.com</Link> </p> */}
                                </div>
                                <div className="footer-social-inline">
                                    <a href="https://www.linkedin.com/company/17879528/admin/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
                                    <a href="https://twitter.com/_ikabit" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
                                    <a href="https://www.facebook.com/ikabitinc" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
                                    <a href="https://www.instagram.com/ikabitinc/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    

                    {FooterData && FooterData.map((single, key) => {
                            return(
                                <>
                                <div key={key} className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6 mb-6">
                                    <FooterLinkItem data={single} key={key} />
                                </div>
                                
                            </>
                            ); 
                    })}
                    
                            

                </div>
                
                <div className="row">
               
                    <div className="col" style={{display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                        
                        <p style={{padding:'5px 0',textAlign:'left'}} className="copyright">&copy; Ikabit Inc. {CurrentYear} | Built By <a target="_blank" rel="noopener noreferrer" href="https://www.ikabitss.com/"><strong>Ikabit</strong></a>.</p>
                        {/* <p style={{padding:'5px 0',textAlign:'right'}} className="copyright"><a rel="noopener noreferrer" href="/privacy-policy" >Privacy Policy</a>. 
                       </p> */}

<NavLink to={process.env.PUBLIC_URL + "/privacy-policy"} style={{padding:'5px 0',textAlign:'right'}} className="copyright" ><a rel="noopener noreferrer"> Privacy Policy</a>.
</NavLink>


                    </div>
                  
                </div>
                

            </div> 
        </div>
    )
}

export default Footer
